module.exports = __webpack_public_path__ + "static/media/md-refresh-circle.bf1d0ba5.svg";